import BasicTable from "../../tailwindComponents/tables/basic-table.component";

interface ColumnItem {
    name: string;
    sortable?: boolean;
    customFormatting?: (value: string | number) => JSX.Element
    customClassName?: string;
}

interface ReportTableProps {
    columns: Array<string | ColumnItem>;
    data: Array<Array<string | number>>;
    rowClassName?: (rowIndex: number) => string|null;
    defaultSortColumn?: string | null;
    defaultSortDirection?: "asc" | "desc";
    headerClassName?: string;
    toPdf?: () => void;
    toCsv?: () => void;
}

const ReportTable: React.FC<ReportTableProps> = ({
    columns,
    data,
    rowClassName,
    defaultSortColumn = null,
    defaultSortDirection = "desc",
    headerClassName = "px-4 py-2 border border-gray-300 text-left font-medium text-gray-700",
    toPdf,
    toCsv
}) => {
    return (
        <div className="overflow-x-auto">
            {(toPdf || toCsv) && (
                <div className="flex justify-end gap-2 mb-2">
                    {toPdf && (
                        <button 
                            onClick={() => (window as any).BaseReportExport && (window as any).BaseReportExport('pdf')}
                            className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 text-sm"
                        >
                            Export PDF
                        </button>
                    )}
                    {toCsv && (
                        <button 
                            onClick={() => (window as any).BaseReportExport && (window as any).BaseReportExport('csv')}
                            className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600 text-sm"
                        >
                            Export CSV
                        </button>
                    )}
                </div>
            )}
            <BasicTable
                columns={columns}
                data={data}
                rowClassName={rowClassName}
                defaultSortColumn={defaultSortColumn}
                defaultSortDirection={defaultSortDirection}
                headerClassName={headerClassName}
            />
        </div>
    );
};

export default ReportTable;